const pricingTypes = [
  "default",
  "single",
  "square",
  "starting",
  "digital",
  "size",
  "custom",
  "common",
];

module.exports = {
  pricingTypes,
};
